export default __webpack_public_path__ + "static/media/property_506.6ad87d21.png";